// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"1c850048","130":"9f9cdec8","236":"d6b0c284","338":"b84a38cb","375":"bf3f42ec","381":"debf97de","420":"004903f6","681":"a27cac67","794":"e8c5d49e","916":"f180daef"}[chunkId] + ".chunk.css";
};